module.exports = __webpack_public_path__ + "img/beckTestIcon.ca07a7df.svg";